/**
 * API base — same-origin by default.
 * 
 * In production: /api/* hits the edge worker or GRAYMANTLE control-server directly.
 * In dev: Vite proxy forwards /api to localhost:8088 (GRAYMANTLE Gate).
 * 
 * Three backend surfaces:
 *   - /api/frontier/*  → frontier worker (F0-F13 pipeline)
 *   - /api/envoy/*     → envoy worker (campaigns, sequences, contacts)
 *   - /api/*           → GRAYMANTLE control-server (register, agent, conveyance)
 */

export function frontierApi(path: string): string {
  const base = import.meta.env.VITE_FRONTIER_WORKER_URL?.replace(/\/$/, "") ?? "";
  const apiPath = path.startsWith("/api/") ? path : `/api/frontier/${path.replace(/^\//, "")}`;
  return base ? `${base}${apiPath}` : apiPath;
}

export function envoyApi(path: string): string {
  const base = import.meta.env.VITE_ENVOY_WORKER_URL?.replace(/\/$/, "") ?? "";
  const apiPath = path.startsWith("/api/") ? path : `/api/envoy/${path.replace(/^\//, "")}`;
  return base ? `${base}${apiPath}` : apiPath;
}

export function controlApi(path: string): string {
  const base = import.meta.env.VITE_CONTROL_SERVER_URL?.replace(/\/$/, "") ?? "";
  const apiPath = path.startsWith("/api/") ? path : `/api/${path.replace(/^\//, "")}`;
  return base ? `${base}${apiPath}` : apiPath;
}
